import { createSlice } from '@reduxjs/toolkit'
import { API_GET_FEATURED_LISTINGS } from '../constants/index'

const initialState = {
    featuredListings: [],
    isLoading: false,
}

export const getFeaturedListings = (search = '') => ({
    type: 'API',
    payload: {
        url: search
            ? `${API_GET_FEATURED_LISTINGS}?search=${encodeURIComponent(search)}`
            : API_GET_FEATURED_LISTINGS,
        method: 'GET',
        hideLoader: false,
        success: (data) => ({
            type: 'getFeaturedListings/success',
            payload: data,
        }),
        error: () => ({
            type: 'getFeaturedListings/fail',
            payload: [],
        }),
    },
})

const FeaturedListingsSlice = createSlice({
    name: 'FeaturedListings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase('getFeaturedListings/success', (state, action) => {
            state.featuredListings = action.payload?.data ?? []
        })
        builder.addCase('getFeaturedListings/fail', (state) => {
            state.featuredListings = []
        })
    },
})

export default FeaturedListingsSlice.reducer
